import { createAction, props } from '@ngrx/store';
import { IApiCityResponse } from 'src/app/api/interfaces/city.interface';

export const setInitialCityData = createAction(
  '[City API] set initial data Success',
  props<{ responseData: IApiCityResponse }>()
);
export const updateCityData = createAction(
  '[City API] update data Success',
  props<{ responseData: IApiCityResponse }>()
);
